import React, { useEffect } from "react"
import Layout from "~/components/Layout";
import { useLang } from "~/hooks/useLang";
import AuditDispatchGroupReportTable from "../components/DispatchGroup";

export default function AuditDispatchGroupReport() {
    const { translate } = useLang();

    useEffect(() => {
        document.title = translate('Dispatch Group report Audit - Dispatch System')
    }, [])
    return (
        <Layout marginLayout={true}>
            <AuditDispatchGroupReportTable />
        </Layout>
    )
}